export const pathHome = "/";
export const pathAziendaHome = "/azienda/home";
export const pathAziendaAdd = "/azienda/manage";
export const pathFascicoloHome = "/fascicolo";
export const pathFascicoloNew = "/fascicolo/new";
export const pathFascicoloAdd = "/fascicolo/manage";
export const pathAnagraficaHome = "/anagrafica";
export const pathAnagraficaImportDesktop = "/anagrafica/import";
export const pathPrestazioneHome = "/prestazione";
export const pathRischioHome = "/rischio";
export const pathAutoValutazioneHome = "/autovalutazione";
export const pathAutoValutazioneAdd = "/autovalutazione/manage";
export const pathSegnalazioneHome = "/segnalazione";
export const pathNormativaHome = "/normativa";
export const pathImpTabBaseHome = "/impostazioni/tabellabase";
export const pathImpUtenteHome = "/impostazioni/utente";
export const pathImpPermessoHome = "/impostazioni/permesso";
export const pathImpAuditHome = "/impostazioni/audit";
export const pathReleaseNotesHome = "/impostazioni/releaseNotes";
export const pathExportDatiHome = "/export";
export const pathNominationHome = "/impostazioni/nominations"